export default __webpack_public_path__ + "static/media/hamburger-gallery.71eba5e8.svg";